import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { Box } from '@bonanza-social/moonlight';
import { selectCommunityJackpotEvents } from '../../../../state';
import JackpotProgressMilestone from './JackpotProgressMilestone/JackpotProgressMilestone';

function JackpotProgressMilestones() {
  const [event] = useSelector(selectCommunityJackpotEvents);

  return (
    <Box flex={1} flexDirection="column-reverse">
      {event.milestones.map((milestone, index) => (
        <JackpotProgressMilestone
          key={milestone.id}
          goalCardDisabled={
            index !== event.milestones.length - 1 &&
            milestone.status === 'Completed'
          }
          jackpotCardHighlighted={milestone.status !== 'Completed'}
          {...milestone}
        />
      ))}
    </Box>
  );
}

export default memo(JackpotProgressMilestones);
